export default __webpack_public_path__ + "static/media/er.8edd9d8f.png";